@if (person()) {
    <div class="flex flex-col gap-10 grow overflow-y-auto">
        <div class="flex flex-col gap-10">
            <section class="flex flex-col gap-3.5">
                <span class="text-base font-medium">{{ 'license' | transloco: { COUNT: licenses().length } }}</span>
                <ul class="flex flex-row list-none m-0 p-0 gap-5">
                    @for (license of licenses(); track license.id) {
                        <li>
                            <app-logo
                                logoClasses="w-7"
                                [application]="license.application"
                                [matTooltip]="license.application" />
                        </li>
                    } @empty {
                        <li class="flex p-2">
                            <span>-</span>
                        </li>
                    }
                </ul>
            </section>
            @if (connectServiceLicense()?.streetViewQuota && connectServiceLicense()?.streetViewQuotaRemaining) {
                <section class="flex flex-col gap-3.5">
                    <span class="text-base font-medium">{{
                        'streetView.availableRequestsByGrantedRequest' | transloco
                    }}</span>
                    <span class="text-base font-normal"
                        >{{ connectServiceLicense()!.streetViewQuotaRemaining }} /
                        {{ connectServiceLicense()!.streetViewQuota }}</span
                    >
                </section>
            }
            @if (role()) {
                <section class="flex flex-col gap-3.5">
                    <span class="text-base font-medium">{{ 'role' | transloco: { COUNT: 1 } }} </span>
                    <span class="text-base font-normal">{{ role()?.name }}</span>
                </section>
            }

            @if (organizationAccessPermissionsService.canAccessUserProjects()) {
                <app-user-detail-project-list [personId]="person()!.id" />
            }

            @if (organizationAccessPermissionsService.canAccessUserInterventions()) {
                <app-user-detail-field-intervention-list [personId]="person()!.id" />
            }
        </div>
    </div>
}
